// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_card_type from "../../commonapis/gen/buhta_common_v1_card_type.js";
import * as Buhta_commonapis__Buhta_common_v1_iso4217 from "../../commonapis/gen/buhta_common_v1_iso4217.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_card_transfer.ml",
      92,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "CardTransfer"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Payroll"
        ]]
    });

const Payroll = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_card_transfer.ml",
      144,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "CardTransfer"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_card_transfer.ml",
      194,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "CardTransfer"
        ]]
    });

const CardTransfer = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_card_transfer.ml",
      242,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.v1alpha1.CardTransfer";
}

function make(idOpt, stateOpt, payout_txn_typeOpt, payout_txn_idOpt, post_time, process_time, saved_card_idOpt, card_number_sixOpt, card_number_fourOpt, card_issuer_network, card_issuer_bank, currency_codeOpt, sent_amountOpt, fee_amountOpt, total_amountOpt, cancel_time, cancel_reason_codeOpt, cancel_reason_messageOpt, payout_txn_refnumOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const state = stateOpt !== undefined ? stateOpt : "";
  const payout_txn_type = payout_txn_typeOpt !== undefined ? payout_txn_typeOpt : "";
  const payout_txn_id = payout_txn_idOpt !== undefined ? payout_txn_idOpt : "";
  const saved_card_id = saved_card_idOpt !== undefined ? saved_card_idOpt : "";
  const card_number_six = card_number_sixOpt !== undefined ? card_number_sixOpt : "";
  const card_number_four = card_number_fourOpt !== undefined ? card_number_fourOpt : "";
  const currency_code = currency_codeOpt !== undefined ? currency_codeOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0);
  const sent_amount = sent_amountOpt !== undefined ? sent_amountOpt : "";
  const fee_amount = fee_amountOpt !== undefined ? fee_amountOpt : "";
  const total_amount = total_amountOpt !== undefined ? total_amountOpt : "";
  const cancel_reason_code = cancel_reason_codeOpt !== undefined ? cancel_reason_codeOpt : "";
  const cancel_reason_message = cancel_reason_messageOpt !== undefined ? cancel_reason_messageOpt : "";
  const payout_txn_refnum = payout_txn_refnumOpt !== undefined ? payout_txn_refnumOpt : "";
  return {
          id: id,
          state: state,
          payout_txn_type: payout_txn_type,
          payout_txn_id: payout_txn_id,
          post_time: post_time,
          process_time: process_time,
          saved_card_id: saved_card_id,
          card_number_six: card_number_six,
          card_number_four: card_number_four,
          card_issuer_network: card_issuer_network,
          card_issuer_bank: card_issuer_bank,
          currency_code: currency_code,
          sent_amount: sent_amount,
          fee_amount: fee_amount,
          total_amount: total_amount,
          cancel_time: cancel_time,
          cancel_reason_code: cancel_reason_code,
          cancel_reason_message: cancel_reason_message,
          payout_txn_refnum: payout_txn_refnum
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_state = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "state",
            "state"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_payout_txn_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "payout_txn_type",
            "payoutTxnType"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_payout_txn_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "payout_txn_id",
            "payoutTxnId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_post_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            5,
            "post_time",
            "postTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_process_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "process_time",
            "processTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const merge_saved_card_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "saved_card_id",
            "savedCardId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_card_number_six = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            10,
            "card_number_six",
            "cardNumberSix"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_card_number_four = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "card_number_four",
            "cardNumberFour"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$2 = Buhta_commonapis__Buhta_common_v1_card_type.Buhta.Common.V1.CardIssuerNetwork;

const merge_card_issuer_network = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            12,
            "card_issuer_network",
            "cardIssuerNetwork"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const $$let$3 = Buhta_commonapis__Buhta_common_v1_card_type.Buhta.Common.V1.CardIssuerBank;

const merge_card_issuer_bank = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            13,
            "card_issuer_bank",
            "cardIssuerBank"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

const merge_currency_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            14,
            "currency_code",
            "currencyCode"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
          Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
        ]));

const merge_sent_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            15,
            "sent_amount",
            "sentAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_fee_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            16,
            "fee_amount",
            "feeAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_total_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            17,
            "total_amount",
            "totalAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_cancel_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            18,
            "cancel_time",
            "cancelTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

const merge_cancel_reason_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            19,
            "cancel_reason_code",
            "cancelReasonCode"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_cancel_reason_message = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            20,
            "cancel_reason_message",
            "cancelReasonMessage"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_payout_txn_refnum = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            21,
            "payout_txn_refnum",
            "payoutTxnRefnum"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          state: Curry._2(merge_state, t1.state, t2.state),
          payout_txn_type: Curry._2(merge_payout_txn_type, t1.payout_txn_type, t2.payout_txn_type),
          payout_txn_id: Curry._2(merge_payout_txn_id, t1.payout_txn_id, t2.payout_txn_id),
          post_time: Curry._2(merge_post_time, t1.post_time, t2.post_time),
          process_time: Curry._2(merge_process_time, t1.process_time, t2.process_time),
          saved_card_id: Curry._2(merge_saved_card_id, t1.saved_card_id, t2.saved_card_id),
          card_number_six: Curry._2(merge_card_number_six, t1.card_number_six, t2.card_number_six),
          card_number_four: Curry._2(merge_card_number_four, t1.card_number_four, t2.card_number_four),
          card_issuer_network: Curry._2(merge_card_issuer_network, t1.card_issuer_network, t2.card_issuer_network),
          card_issuer_bank: Curry._2(merge_card_issuer_bank, t1.card_issuer_bank, t2.card_issuer_bank),
          currency_code: Curry._2(merge_currency_code, t1.currency_code, t2.currency_code),
          sent_amount: Curry._2(merge_sent_amount, t1.sent_amount, t2.sent_amount),
          fee_amount: Curry._2(merge_fee_amount, t1.fee_amount, t2.fee_amount),
          total_amount: Curry._2(merge_total_amount, t1.total_amount, t2.total_amount),
          cancel_time: Curry._2(merge_cancel_time, t1.cancel_time, t2.cancel_time),
          cancel_reason_code: Curry._2(merge_cancel_reason_code, t1.cancel_reason_code, t2.cancel_reason_code),
          cancel_reason_message: Curry._2(merge_cancel_reason_message, t1.cancel_reason_message, t2.cancel_reason_message),
          payout_txn_refnum: Curry._2(merge_payout_txn_refnum, t1.payout_txn_refnum, t2.payout_txn_refnum)
        };
}

function spec(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$2 = Buhta_commonapis__Buhta_common_v1_card_type.Buhta.Common.V1.CardIssuerNetwork;
  const $$let$3 = Buhta_commonapis__Buhta_common_v1_card_type.Buhta.Common.V1.CardIssuerBank;
  const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "state",
                        "state"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "payout_txn_type",
                            "payoutTxnType"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "payout_txn_id",
                                "payoutTxnId"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    5,
                                    "post_time",
                                    "postTime"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: $$let.name,
                                        make: $$let.make,
                                        from_proto: $$let.from_proto,
                                        from_proto_exn: $$let.from_proto_exn,
                                        to_proto: $$let.to_proto,
                                        to_proto$p: $$let.to_proto$p,
                                        merge: $$let.merge,
                                        to_json: $$let.to_json,
                                        from_json_exn: $$let.from_json_exn,
                                        from_json: $$let.from_json
                                      })
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "process_time",
                                        "processTime"
                                      ],
                                      Ocaml_protoc_plugin__Spec.message({
                                            name: $$let$1.name,
                                            make: $$let$1.make,
                                            from_proto: $$let$1.from_proto,
                                            from_proto_exn: $$let$1.from_proto_exn,
                                            to_proto: $$let$1.to_proto,
                                            to_proto$p: $$let$1.to_proto$p,
                                            merge: $$let$1.merge,
                                            to_json: $$let$1.to_json,
                                            from_json_exn: $$let$1.from_json_exn,
                                            from_json: $$let$1.from_json
                                          })
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "saved_card_id",
                                            "savedCardId"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                10,
                                                "card_number_six",
                                                "cardNumberSix"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string,
                                              ""
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                  [
                                                    11,
                                                    "card_number_four",
                                                    "cardNumberFour"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string,
                                                  ""
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                      [
                                                        12,
                                                        "card_issuer_network",
                                                        "cardIssuerNetwork"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.message({
                                                            name: $$let$2.name,
                                                            make: $$let$2.make,
                                                            from_proto: $$let$2.from_proto,
                                                            from_proto_exn: $$let$2.from_proto_exn,
                                                            to_proto: $$let$2.to_proto,
                                                            to_proto$p: $$let$2.to_proto$p,
                                                            merge: $$let$2.merge,
                                                            to_json: $$let$2.to_json,
                                                            from_json_exn: $$let$2.from_json_exn,
                                                            from_json: $$let$2.from_json
                                                          })
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                          [
                                                            13,
                                                            "card_issuer_bank",
                                                            "cardIssuerBank"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.message({
                                                                name: $$let$3.name,
                                                                make: $$let$3.make,
                                                                from_proto: $$let$3.from_proto,
                                                                from_proto_exn: $$let$3.from_proto_exn,
                                                                to_proto: $$let$3.to_proto,
                                                                to_proto$p: $$let$3.to_proto$p,
                                                                merge: $$let$3.merge,
                                                                to_json: $$let$3.to_json,
                                                                from_json_exn: $$let$3.from_json_exn,
                                                                from_json: $$let$3.from_json
                                                              })
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                14,
                                                                "currency_code",
                                                                "currencyCode"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
                                                              Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                  [
                                                                    15,
                                                                    "sent_amount",
                                                                    "sentAmount"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                  ""
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                      [
                                                                        16,
                                                                        "fee_amount",
                                                                        "feeAmount"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.string,
                                                                      ""
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                          [
                                                                            17,
                                                                            "total_amount",
                                                                            "totalAmount"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.string,
                                                                          ""
                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                              [
                                                                                18,
                                                                                "cancel_time",
                                                                                "cancelTime"
                                                                              ],
                                                                              Ocaml_protoc_plugin__Spec.message({
                                                                                    name: $$let$4.name,
                                                                                    make: $$let$4.make,
                                                                                    from_proto: $$let$4.from_proto,
                                                                                    from_proto_exn: $$let$4.from_proto_exn,
                                                                                    to_proto: $$let$4.to_proto,
                                                                                    to_proto$p: $$let$4.to_proto$p,
                                                                                    merge: $$let$4.merge,
                                                                                    to_json: $$let$4.to_json,
                                                                                    from_json_exn: $$let$4.from_json_exn,
                                                                                    from_json: $$let$4.from_json
                                                                                  })
                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                  [
                                                                                    19,
                                                                                    "cancel_reason_code",
                                                                                    "cancelReasonCode"
                                                                                  ],
                                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                                  ""
                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                      [
                                                                                        20,
                                                                                        "cancel_reason_message",
                                                                                        "cancelReasonMessage"
                                                                                      ],
                                                                                      Ocaml_protoc_plugin__Spec.string,
                                                                                      ""
                                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                          [
                                                                                            21,
                                                                                            "payout_txn_refnum",
                                                                                            "payoutTxnRefnum"
                                                                                          ],
                                                                                          Ocaml_protoc_plugin__Spec.string,
                                                                                          ""
                                                                                        ]), Ocaml_protoc_plugin__Spec.nil)))))))))))))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry.app(serialize, [
        writer,
        param.id,
        param.state,
        param.payout_txn_type,
        param.payout_txn_id,
        param.post_time,
        param.process_time,
        param.saved_card_id,
        param.card_number_six,
        param.card_number_four,
        param.card_issuer_network,
        param.card_issuer_bank,
        param.currency_code,
        param.sent_amount,
        param.fee_amount,
        param.total_amount,
        param.cancel_time,
        param.cancel_reason_code,
        param.cancel_reason_message,
        param.payout_txn_refnum
      ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, state, payout_txn_type, payout_txn_id, post_time, process_time, saved_card_id, card_number_six, card_number_four, card_issuer_network, card_issuer_bank, currency_code, sent_amount, fee_amount, total_amount, cancel_time, cancel_reason_code, cancel_reason_message, payout_txn_refnum) {
  return {
          id: id,
          state: state,
          payout_txn_type: payout_txn_type,
          payout_txn_id: payout_txn_id,
          post_time: post_time,
          process_time: process_time,
          saved_card_id: saved_card_id,
          card_number_six: card_number_six,
          card_number_four: card_number_four,
          card_issuer_network: card_issuer_network,
          card_issuer_bank: card_issuer_bank,
          currency_code: currency_code,
          sent_amount: sent_amount,
          fee_amount: fee_amount,
          total_amount: total_amount,
          cancel_time: cancel_time,
          cancel_reason_code: cancel_reason_code,
          cancel_reason_message: cancel_reason_message,
          payout_txn_refnum: payout_txn_refnum
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha1.CardTransfer", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param.state,
                param.payout_txn_type,
                param.payout_txn_id,
                param.post_time,
                param.process_time,
                param.saved_card_id,
                param.card_number_six,
                param.card_number_four,
                param.card_issuer_network,
                param.card_issuer_bank,
                param.currency_code,
                param.sent_amount,
                param.fee_amount,
                param.total_amount,
                param.cancel_time,
                param.cancel_reason_code,
                param.cancel_reason_message,
                param.payout_txn_refnum
              ]);
  };
}

function constructor$1(id, state, payout_txn_type, payout_txn_id, post_time, process_time, saved_card_id, card_number_six, card_number_four, card_issuer_network, card_issuer_bank, currency_code, sent_amount, fee_amount, total_amount, cancel_time, cancel_reason_code, cancel_reason_message, payout_txn_refnum) {
  return {
          id: id,
          state: state,
          payout_txn_type: payout_txn_type,
          payout_txn_id: payout_txn_id,
          post_time: post_time,
          process_time: process_time,
          saved_card_id: saved_card_id,
          card_number_six: card_number_six,
          card_number_four: card_number_four,
          card_issuer_network: card_issuer_network,
          card_issuer_bank: card_issuer_bank,
          currency_code: currency_code,
          sent_amount: sent_amount,
          fee_amount: fee_amount,
          total_amount: total_amount,
          cancel_time: cancel_time,
          cancel_reason_code: cancel_reason_code,
          cancel_reason_message: cancel_reason_message,
          payout_txn_refnum: payout_txn_refnum
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha1.CardTransfer", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CardTransfer, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "CardTransfer"
        ]]
    }, V1alpha1, {
      CardTransfer: CardTransfer
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "CardTransfer"
              ]]
          },
          "V1alpha1"
        ]]
    }, Payroll, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "CardTransfer"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Payroll"
        ]]
    }, Buhta, {
      Payroll: Payroll
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
